import React from 'react'
import propTypes from 'prop-types'

import { Card } from '@components/layout/Card'
import { AssetsProvider } from './context'
import { Views } from './Views'
import { Header } from './components/Header'

export const Assets = (props) => {
  return (
    <AssetsProvider {...props}>
      <Card className='ui-card--asset scenario-plan-assets'>
        <Header />
        <Views />
      </Card>
    </AssetsProvider>
  )
}

Assets.propTypes = {
  scenario: propTypes.shape({
    id: propTypes.number,
    planType: propTypes.string,
    isRetired: propTypes.bool,
    retirementAge: propTypes.number
  }),
  tenant: propTypes.object.isRequired,
  assets: propTypes.arrayOf(propTypes.object).isRequired,
  totalContributions: propTypes.number,
  totalCapital: propTypes.number,
  crudActions: propTypes.object,
  riskProfile: propTypes.object,
  assumptions: propTypes.object,
  assetView: propTypes.oneOf(['grid', 'list']),
  serviceProviders: propTypes.array,
  supportedCurrencies: propTypes.object,
  featureToggles: propTypes.object,
  featureConfig: propTypes.object,
  userDetails: propTypes.object,
  filter: propTypes.func
}
